import {
  GET_MAP_CONTROLS_REFRESH_MAP,
  GET_MAP_CONTROLS_EXTERNAL_REFRESH_MAP,
  GET_MAP_CONTROLS_EXTERNAL_SOURCE_ID,
  GET_MAP_CONTROLS_PARAMS,
} from "./actions.type";
import {
  SET_MAP_CONTROLS_REFRESH_MAP,
  SET_MAP_CONTROLS_EXTERNAL_REFRESH_MAP,
  SET_MAP_CONTROLS_EXTERNAL_SOURCE_ID,
  SET_MAP_CONTROLS_PARAMS,
} from "./mutations.type";

const STATE = {
  refreshMap: false,
  externalRefreshMap: false,
  externalSourceId: null,
  params: {
    mapPointsControlEnabled: false, // Defines toggle to enable/disable all including selected
    mapOverlaysControlEnabled: false, // Defines toggle to enable/disable even selected
    mapExternalControlEnabled: false, // Defines toggle to enable/disable even selected
    mapOverlaysControlSelectedType: null, // Defines selected overlay type
    mapPointsControlSelectedTypes: [], // Defines list of selected points type
    mapExternalControlSelected: null, // Defines selected external layer
    timestamp: null,
  },
};

const GETTERS = {
  refreshMap: (state) => state.refreshMap,
  externalRefreshMap: (state) => state.externalRefreshMap,
  externalSourceId: (state) => state.externalSourceId,
  params: (state) => state.params,
};

const ACTIONS = {
  [GET_MAP_CONTROLS_REFRESH_MAP](context, data) {
    context.commit(SET_MAP_CONTROLS_REFRESH_MAP, data);
  },
  [GET_MAP_CONTROLS_EXTERNAL_REFRESH_MAP](context, data) {
    context.commit(SET_MAP_CONTROLS_EXTERNAL_REFRESH_MAP, data);
  },
  [GET_MAP_CONTROLS_EXTERNAL_SOURCE_ID](context, data) {
    context.commit(SET_MAP_CONTROLS_EXTERNAL_SOURCE_ID, data);
  },
  [GET_MAP_CONTROLS_PARAMS](context, params) {
    params.timestamp = Date.now();
    context.commit(SET_MAP_CONTROLS_PARAMS, params);
  },
};

const MUTATIONS = {
  [SET_MAP_CONTROLS_REFRESH_MAP](state, data) {
    state.refreshMap = data;
  },
  [SET_MAP_CONTROLS_EXTERNAL_REFRESH_MAP](state, data) {
    state.externalRefreshMap = data;
  },
  [SET_MAP_CONTROLS_EXTERNAL_SOURCE_ID](state, data) {
    state.externalSourceId = data;
  },
  [SET_MAP_CONTROLS_PARAMS](state, params) {
    state.params = params;
  },
};

export default {
  namespaced: true,
  state: STATE,
  actions: ACTIONS,
  mutations: MUTATIONS,
  getters: GETTERS,
};
